export default "__VITE_ASSET__I4whRhHl__"